import EmbeddedFormPage from './EmbeddedFormPage';

const TriSharePage = () => (
  <EmbeddedFormPage
    titleKey="Tri-Share"
    description="Fill out this form to enroll in Tri-Share. Tri-Share is an employer-supported childcare benefit where the cost of care is split between the family, their employer, and the state — making care more affordable for working parents."
    formUrl="https://wonderschool.fillout.com/t/hbac2yqkUkus"
  />
);

export default TriSharePage;
